import "./whatsapp.css";
import WhatsAppLogo from "../../assets/images/whatsapp.png";

function Whatsapp() {
  return (
    <div className="whatsapp-float-container">
      <a
        href="https://wa.me/5511954242066?text=Olá!%20Gostaria%20de%20um%20atendimento%20jurídico."
        className="whatsapp-float pulse-glow"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com Antonio Saldanha Advocacia no WhatsApp"
        title="Falar no WhatsApp"
      >
        <img
          src={WhatsAppLogo}
          alt="WhatsApp Antonio Saldanha Advocacia"
          width="54"
          height="54"
        />
        <span className="whatsapp-tooltip d-none d-md-block">
          Atendimento WhatsApp
        </span>
      </a>
    </div>
  );
}

export default Whatsapp;
